var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEyeOpen = function SvgEyeOpen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 7,
    viewBox: "0 0 14 7",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 7C10.866 7 12.9414 4.95339 14 3.5C12.9414 2.04661 10.866 0 7 0C3.13401 0 1.20988 1.83898 0 3.5C1.08025 4.98305 3.13401 7 7 7ZM7.21737 6.69564C8.98228 6.69564 10.413 5.2649 10.413 3.49999C10.413 1.73508 8.98228 0.304338 7.21737 0.304338C5.45246 0.304338 4.02172 1.73508 4.02172 3.49999C4.02172 5.2649 5.45246 6.69564 7.21737 6.69564Z",
    fill: "#4D4D4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.21745 6.08694C8.64619 6.08694 9.80441 4.92872 9.80441 3.49998C9.80441 2.07124 8.64619 0.913025 7.21745 0.913025C6.97861 0.913025 6.74733 0.945391 6.52776 1.00598C6.85062 1.16007 7.07371 1.48956 7.07371 1.87116C7.07371 2.40032 6.64474 2.8293 6.11557 2.8293C5.60698 2.8293 5.19094 2.43302 5.15937 1.93239C4.82755 2.36736 4.63049 2.91066 4.63049 3.49998C4.63049 4.92872 5.78871 6.08694 7.21745 6.08694Z",
    fill: "#4D4D4F"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEyeOpen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye-open.57493084.svg";
export { ForwardRef as ReactComponent };